import React, { useEffect, useMemo, useRef, useState } from 'react';

const SVG_SIZE = 360;
const MAP_WIDTH = 720;
const MAP_HEIGHT = 360;
const GLOBE_RADIUS = 154;
const GLOBE_CENTER = SVG_SIZE / 2;

const LANDMASSES = [
  // North America
  [
    [-168, 72], [-162, 71], [-156, 70], [-150, 70], [-143, 68], [-140, 67],
    [-137, 62], [-135, 60], [-131, 56], [-127, 53], [-125, 50], [-124, 48],
    [-124, 45], [-124, 41], [-122, 38], [-120, 36], [-118, 34], [-117, 32],
    [-115, 30], [-110, 25], [-106, 20], [-100, 18], [-93, 16], [-88, 16],
    [-83, 10], [-78, 9], [-76, 10], [-78, 14], [-82, 16], [-85, 16],
    [-88, 16], [-92, 19], [-95, 22], [-97, 26], [-97, 30], [-93, 29],
    [-89, 30], [-84, 30], [-81, 26], [-80, 28], [-80, 33], [-77, 35],
    [-75, 37], [-74, 40], [-71, 41], [-70, 42], [-66, 44], [-63, 46],
    [-60, 46], [-54, 48], [-53, 51], [-55, 53], [-60, 55], [-63, 58],
    [-63, 61], [-65, 64], [-69, 67], [-70, 69], [-68, 71], [-72, 73],
    [-80, 74], [-90, 77], [-100, 77], [-110, 74], [-120, 72], [-130, 71],
    [-140, 70], [-150, 70], [-158, 70], [-165, 68], [-168, 72],
  ],
  // Greenland
  [
    [-73, 83], [-60, 83], [-44, 82], [-28, 77], [-18, 69], [-20, 63],
    [-27, 60], [-36, 57], [-44, 59], [-52, 64], [-58, 68], [-65, 74],
    [-73, 80], [-73, 83],
  ],
  // South America
  [
    [-81, 12], [-77, 8], [-75, 5], [-74, 2], [-72, -2], [-71, -6],
    [-71, -11], [-70, -16], [-68, -21], [-66, -25], [-63, -30], [-60, -35],
    [-57, -39], [-54, -44], [-51, -49], [-47, -53], [-44, -56], [-40, -54],
    [-38, -48], [-36, -40], [-38, -34], [-40, -28], [-41, -21], [-43, -14],
    [-46, -8], [-50, -4], [-54, -2], [-58, 0], [-60, 1], [-63, 4],
    [-66, 7], [-69, 9], [-72, 11], [-78, 10], [-81, 12],
  ],
  // Eurasia main body (simple non-self-intersecting outer polygon, clockwise)
  [
    // SW Iberia → Mediterranean → Turkey → Black Sea
    [-9, 36], [-5, 36], [-2, 36], [2, 37], [6, 38], [10, 38], [14, 41],
    [18, 40], [22, 38], [26, 38], [28, 36], [30, 38], [34, 38],
    [36, 42], [38, 42], [40, 40], [42, 42], [44, 43], [48, 44],
    // Caspian → Central Asia → Middle East coast
    [52, 40], [54, 38], [58, 38], [62, 36], [62, 28], [58, 22],
    [56, 22], [58, 18], [62, 14], [66, 14], [68, 20], [72, 22],
    // India west coast → tip → east coast
    [74, 18], [76, 10], [78, 8], [80, 12], [80, 18],
    // SE Asia → Indochina
    [84, 14], [88, 14], [92, 20], [96, 18], [98, 10],
    [100, 6], [104, 4], [104, 10], [108, 16],
    // China coast → Korea → Russian Far East
    [112, 20], [116, 22], [120, 24], [122, 30],
    [122, 38], [124, 42], [128, 48], [132, 50],
    [136, 54], [140, 54], [142, 56], [142, 60], [143, 64],
    // NE Siberia arc → Arctic coast going west
    [144, 68], [158, 66], [164, 66], [164, 70], [154, 74],
    [140, 72], [128, 74], [116, 74], [104, 76],
    [90, 78], [74, 76], [58, 74], [44, 72],
    // Kola / Scandinavian base → W Europe N coast
    [32, 70], [28, 70], [22, 70], [20, 68], [16, 68],
    [14, 62], [10, 58], [8, 56], [10, 54],
    // N German coast → North Sea → NW France → Bay of Biscay → W Iberia
    [14, 54], [10, 54], [6, 54], [4, 52], [2, 52],
    [-2, 50], [-4, 48], [-8, 44], [-8, 40], [-9, 38], [-9, 36],
  ],
  // Scandinavia (separate simple polygon)
  [
    [5, 58], [4, 60], [5, 62], [6, 62], [8, 64], [10, 63],
    [14, 68], [16, 68], [20, 68], [22, 68], [28, 68], [30, 66],
    [28, 62], [24, 60], [22, 58], [20, 56], [18, 56], [14, 56],
    [12, 56], [10, 56], [8, 58], [5, 58],
  ],
  // Africa
  [
    [-18, 35], [-13, 34], [-8, 33], [-2, 34], [4, 34], [10, 34], [14, 33],
    [18, 33], [22, 32], [26, 32], [28, 30], [32, 28], [33, 24], [38, 22],
    [40, 18], [42, 14], [44, 12], [43, 10], [42, 8], [42, 4], [42, 0],
    [40, -3], [38, -8], [38, -12], [36, -18], [34, -22], [32, -26],
    [30, -30], [28, -34], [22, -35], [18, -35], [14, -34], [10, -33],
    [6, -30], [2, -24], [-1, -18], [-4, -12], [-6, -6], [-8, -2], [-10, 4],
    [-11, 8], [-12, 12], [-16, 14], [-17, 18], [-18, 22], [-18, 26],
    [-16, 30], [-14, 32], [-12, 35], [-18, 35],
  ],
  // Madagascar
  [
    [49, -12], [51, -14], [51, -18], [50, -22], [48, -25], [45, -26],
    [44, -23], [44, -18], [45, -14], [47, -12], [49, -12],
  ],
  // Australia
  [
    [114, -22], [116, -20], [118, -18], [122, -18], [126, -16], [130, -14],
    [132, -12], [136, -12], [140, -14], [142, -12], [145, -15], [148, -18],
    [150, -22], [152, -26], [154, -28], [154, -32], [152, -36], [150, -38],
    [148, -39], [146, -40], [144, -40], [142, -39], [140, -36], [138, -35],
    [136, -34], [134, -33], [130, -34], [126, -34], [122, -34], [118, -32],
    [116, -30], [114, -28], [112, -26], [112, -22], [114, -22],
  ],
  // Japan (main islands simplified)
  [
    [132, 34], [134, 34], [136, 35], [138, 36], [140, 38], [141, 40],
    [141, 42], [143, 44], [145, 44], [145, 42], [143, 40], [141, 38],
    [140, 36], [138, 34], [136, 34], [134, 33], [132, 34],
  ],
  // Great Britain (simple non-self-intersecting)
  [
    [-5, 50], [-4, 50], [-3, 51], [-2, 51], [0, 52], [1, 53],
    [1, 55], [0, 57], [-2, 58], [-4, 58], [-5, 58], [-5, 56],
    [-4, 54], [-5, 52], [-5, 50],
  ],
  // Ireland
  [
    [-10, 52], [-8, 51], [-6, 52], [-6, 54], [-8, 55], [-10, 54], [-10, 52],
  ],
  // New Zealand (simplified)
  [
    [172, -34], [174, -36], [176, -37], [178, -38], [176, -40],
    [174, -42], [172, -44], [170, -46], [168, -46], [168, -44],
    [170, -42], [172, -40], [174, -38], [174, -36], [172, -34],
  ],
];

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - ((-2 * t + 2) ** 3) / 2;
}

function wrapLongitude(value) {
  let next = value;
  while (next > 180) next -= 360;
  while (next < -180) next += 360;
  return next;
}

function lonToX(lon) {
  return ((lon + 180) / 360) * MAP_WIDTH;
}

function latToY(lat) {
  return ((90 - lat) / 180) * MAP_HEIGHT;
}

function projectPoint(lon, lat, offsetX, offsetY) {
  const baseX = lonToX(wrapLongitude(lon));
  const baseY = latToY(lat);
  const wrappedCandidates = [
    baseX + offsetX - MAP_WIDTH,
    baseX + offsetX,
    baseX + offsetX + MAP_WIDTH,
  ];
  const x = wrappedCandidates.reduce((best, candidate) =>
    Math.abs(candidate - GLOBE_CENTER) < Math.abs(best - GLOBE_CENTER) ? candidate : best
  );
  const y = baseY + offsetY;
  const dx = x - GLOBE_CENTER;
  const dy = y - GLOBE_CENTER;

  if (dx * dx + dy * dy > (GLOBE_RADIUS - 6) * (GLOBE_RADIUS - 6)) {
    return null;
  }

  return [x, y];
}

function buildTargetOffset(entry) {
  const lon = Number.isFinite(entry?.lon) ? wrapLongitude(entry.lon) : -122.1;
  const lat = Number.isFinite(entry?.lat) ? clamp(entry.lat, -70, 70) : 36.95;
  const focusX = lonToX(lon);
  const focusY = latToY(lat);

  return {
    x: GLOBE_CENTER - focusX,
    y: clamp((GLOBE_CENTER - focusY) * 0.72, -92, 92),
  };
}

function toPath(points) {
  return points
    .map(([lon, lat], index) => {
      const x = lonToX(lon).toFixed(2);
      const y = latToY(lat).toFixed(2);
      return `${index === 0 ? 'M' : 'L'} ${x} ${y}`;
    })
    .join(' ') + ' Z';
}

const LAND_PATHS = LANDMASSES.map(toPath);

const GRATICULE_PATHS = [
  ...[-60, -30, 0, 30, 60].map((lat) => `M 0 ${latToY(lat).toFixed(2)} H ${MAP_WIDTH}`),
  ...[-120, -60, 0, 60, 120].map((lon) => `M ${lonToX(lon).toFixed(2)} 0 V ${MAP_HEIGHT}`),
];

export function SignalGlobe({ entries, activeIndex, onSelect, viewerLocation }) {
  const activeEntry = entries[activeIndex] || entries[0] || null;
  const initialOffset = buildTargetOffset(activeEntry);
  const [offset, setOffset] = useState(() => initialOffset);
  const offsetRef = useRef(initialOffset);

  useEffect(() => {
    offsetRef.current = offset;
  }, [offset]);

  useEffect(() => {
    if (!activeEntry) return undefined;

    if (process.env.NODE_ENV === 'test') {
      const targetOffset = buildTargetOffset(activeEntry);
      setOffset(targetOffset);
      offsetRef.current = targetOffset;
      return undefined;
    }

    const requestFrame =
      window.requestAnimationFrame ||
      ((callback) => window.setTimeout(() => callback(performance.now()), 16));
    const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
    const startOffset = offsetRef.current;
    const targetOffset = buildTargetOffset(activeEntry);
    const startTime = performance.now();
    const durationMs = 900;
    let frameId = 0;

    const animate = (timestamp) => {
      const elapsed = clamp((timestamp - startTime) / durationMs, 0, 1);
      const eased = easeInOutCubic(elapsed);
      const nextOffset = {
        x: startOffset.x + (targetOffset.x - startOffset.x) * eased,
        y: startOffset.y + (targetOffset.y - startOffset.y) * eased,
      };

      setOffset(nextOffset);
      offsetRef.current = nextOffset;

      if (elapsed < 1) {
        frameId = requestFrame(animate);
      }
    };

    frameId = requestFrame(animate);

    return () => cancelFrame(frameId);
  }, [activeEntry]);

  const markerLayout = useMemo(
    () =>
      entries
        .map((entry, index) => {
          if (!Number.isFinite(entry?.lon) || !Number.isFinite(entry?.lat)) return null;
          const point = projectPoint(entry.lon, entry.lat, offset.x, offset.y);
          if (!point) return null;

          return {
            entry,
            index,
            left: `${(point[0] / SVG_SIZE) * 100}%`,
            top: `${(point[1] / SVG_SIZE) * 100}%`,
            isActive: index === activeIndex,
          };
        })
        .filter(Boolean),
    [activeIndex, entries, offset.x, offset.y]
  );

  const viewerPoint = useMemo(() => {
    if (!Number.isFinite(viewerLocation?.lon) || !Number.isFinite(viewerLocation?.lat)) return null;
    const point = projectPoint(viewerLocation.lon, viewerLocation.lat, offset.x, offset.y);
    if (!point) return null;
    return {
      left: `${(point[0] / SVG_SIZE) * 100}%`,
      top: `${(point[1] / SVG_SIZE) * 100}%`,
    };
  }, [offset.x, offset.y, viewerLocation]);

  const mapCopies = [offset.x - MAP_WIDTH, offset.x, offset.x + MAP_WIDTH];

  return (
    <div className="atlas-signal-globe-shell">
      <svg
        className="atlas-signal-globe-svg"
        viewBox={`0 0 ${SVG_SIZE} ${SVG_SIZE}`}
        role="img"
        aria-label="Rotating world signal map"
        style={{ imageRendering: 'crisp-edges' }}
      >
        <defs>
          <clipPath id="atlasSignalGlobeClip">
            <circle cx={GLOBE_CENTER} cy={GLOBE_CENTER} r={GLOBE_RADIUS} />
          </clipPath>
          <radialGradient id="atlasSignalGlobeOcean" cx="34%" cy="30%" r="72%">
            <stop offset="0%" stopColor="#b5ddff" />
            <stop offset="42%" stopColor="#4477ca" />
            <stop offset="100%" stopColor="#081c3b" />
          </radialGradient>
          <radialGradient id="atlasSignalGlobeGlow" cx="26%" cy="20%" r="44%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.34)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0)" />
          </radialGradient>
          <linearGradient id="atlasSignalTerminator" x1="0%" x2="100%" y1="0%" y2="0%">
            <stop offset="0%" stopColor="rgba(5,12,22,0.22)" />
            <stop offset="55%" stopColor="rgba(5,12,22,0)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.08)" />
          </linearGradient>
        </defs>

        <circle className="atlas-globe-backdrop" cx={GLOBE_CENTER} cy={GLOBE_CENTER} r={GLOBE_RADIUS + 24} />
        <circle className="atlas-globe-sphere" cx={GLOBE_CENTER} cy={GLOBE_CENTER} r={GLOBE_RADIUS} fill="url(#atlasSignalGlobeOcean)" />
        <g clipPath="url(#atlasSignalGlobeClip)">
          {mapCopies.map((copyX, index) => (
            <g key={`copy-${index}`} transform={`translate(${copyX.toFixed(2)} ${offset.y.toFixed(2)})`}>
              {GRATICULE_PATHS.map((path, pathIndex) => (
                <path key={`grid-${index}-${pathIndex}`} className="atlas-globe-graticule" d={path} shapeRendering="geometricPrecision" />
              ))}
              {LAND_PATHS.map((path, pathIndex) => (
                <path key={`land-${index}-${pathIndex}`} className="atlas-globe-land" d={path} shapeRendering="geometricPrecision" strokeLinejoin="round" />
              ))}
            </g>
          ))}
          <circle cx={GLOBE_CENTER} cy={GLOBE_CENTER} r={GLOBE_RADIUS} fill="url(#atlasSignalGlobeGlow)" />
          <ellipse
            cx={GLOBE_CENTER + 34}
            cy={GLOBE_CENTER}
            rx={GLOBE_RADIUS * 0.92}
            ry={GLOBE_RADIUS * 0.98}
            fill="url(#atlasSignalTerminator)"
          />
        </g>
        <circle className="atlas-globe-rim" cx={GLOBE_CENTER} cy={GLOBE_CENTER} r={GLOBE_RADIUS} />
      </svg>

      {viewerPoint ? (
        <span
          className="atlas-globe-viewer-pin"
          style={{ left: viewerPoint.left, top: viewerPoint.top }}
          aria-hidden="true"
        />
      ) : null}

      {markerLayout.map((marker) => (
        <button
          key={`${marker.entry.id}-${marker.index}`}
          type="button"
          className={`atlas-globe-marker atlas-globe-marker--${marker.entry.theme} ${marker.isActive ? 'is-active' : ''}`}
          style={{ left: marker.left, top: marker.top }}
          onClick={() => onSelect(marker.index)}
          aria-label={`Focus ${marker.entry.title}`}
        >
          <span className="atlas-globe-marker-core" />
          <span className="atlas-globe-marker-halo" />
        </button>
      ))}
    </div>
  );
}

export default SignalGlobe;
